import { render, staticRenderFns } from "./HomeworkQuestNews.vue?vue&type=template&id=76c83112&scoped=true&"
import script from "./HomeworkQuestNews.vue?vue&type=script&lang=js&"
export * from "./HomeworkQuestNews.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkQuestNews.vue?vue&type=style&index=0&id=76c83112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c83112",
  null
  
)

export default component.exports